import React, { useState } from 'react'
import { Link, useLocation, useHistory } from "react-router-dom";
import logo from '../../images/logo-full.png'
import OtpInput, { ResendOTP } from "react-otp-input";
import icon from "../../images/adhaan-icon.png";
import title from "../../images/adhaan-title.png";
import adhaan from "../../images/FlipjoblogoResize.png"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { CircularProgress } from '@mui/material';
import * as constants from '../../utils/Constants'
import registerImg from "../../images/login_bg/registerImg.gif"
import registerImg1 from "../../images/login_bg/registerImg1.gif"

const Register = () => {
  const [isSpin, setIsSpin] = useState(false)
  let state = useLocation().state;
  let history = useHistory()
  if (!state) {
    state = {
      agentName: '',
      emailId: '',
      mobileNumber: '',
      password: '',
      comfirmPassword: '',
      aadharCard: '',
      panCard: ''
    }
  }
  const [loginData, setLoginData] = useState({})
  const handleBlur = (e) => {
    const newLoginData = { ...loginData }
    newLoginData[e.target.name] = e.target.value
    setLoginData(newLoginData)
    // console.log(loginData)
  }
  const submitHandler = (e) => {
    setIsSpin(true)

    if (loginData.agentName && loginData.emailId && loginData.mobileNumber && loginData.password && loginData.aadharCard) {
      // var url = "http://192.168.0.109:8080/api/v1/recruitingAgent/agentRegistration";
      var url = constants.AgentRegistrationUrl;
      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Schema: constants.Schema,
        },
        body: JSON.stringify(loginData)
      })
        .then((response) => response.json())
        .then((res) => {
          // console.log(res)
          if (res.message) {
            toast.success(`✅ ${res.message.messageDescription}!`, {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            })
            setTimeout(() => {
              history.push({
                pathname: '/page-email-otp',
                state: { email: loginData.emailId, mobile: loginData.mobileNumber }
              })
            }, 3000);
          }
          else {
            window.scrollTo(0, 0)
            toast.error(`❌ ${res.error.errorMessage}!`, {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            })
            setTimeout(() => {
              setIsSpin(false)
            }, 3000);
          }
        })
    }
    else {
      window.scrollTo(0, 0)
      toast.error(`❌ Please fill the required fields!`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
      setTimeout(() => {
        setIsSpin(false)
      }, 3000);
      // e.preventDefault()
    }
    // console.log(JSON.stringify(loginData));
  }
  const [input, setInput] = useState({
    agentName: '',
    emailId: '',
    mobileNumber: '',
    password: '',
    confirmPassword: '',
    aadharCard: ''
  });
  const [error, setError] = useState({
    agentName: '',
    emailId: '',
    mobileNumber: '',
    password: '',
    confirmPassword: '',
    aadharCard: ''
  })
  const clearFilter = () => {
    window.location.reload()
  }
  const onInputChange = e => {
    const { name, value } = e.target;
    const newLoginData = { ...loginData }
    newLoginData[e.target.name] = e.target.value
    setLoginData(newLoginData)
    setInput(prev => ({
      ...prev,
      [name]: value
    }));
    validateInput(e);
  }
  const validateInput = e => {
    // if(!isSubmit)
    // return
    let { name, value } = e.target;
    setError(prev => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "agentName":
          if (!value) {
            stateObj[name] = "Please Enter Agent Name.";
          }
          if (value) {
            stateObj[name] = [/[a-zA-Z]+/].every((pattern) =>
              pattern.test(value)

            ) || "Invalid Name"
          }
          break;
        case "emailId":
          if (!value) {
            stateObj[name] = "Please Enter Email Id.";
          }
          if (value) {
            stateObj[name] = [/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/].every((pattern) =>
              pattern.test(value)

            ) || "Invalid Email Id"
          }
          break;
        case "mobileNumber":
          if (!value) {
            stateObj[name] = "Please Enter Mobile Number.";
          }
          else if (value.length < 10) {
            stateObj[name] = "Should be 10 digit Mobile Number"
          }
          break;
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password.";
          } else if (input.confirmPassword && value !== input.confirmPassword) {
            stateObj["confirmPassword"] = "Password and Confirm Password does not match.";
          } else {
            stateObj["confirmPassword"] = input.confirmPassword ? "" : error.confirmPassword;
          }
          break;
        case "confirmPassword":
          if (!value) {
            stateObj[name] = "Please enter Confirm Password.";
          } else if (input.password && value !== input.password) {
            stateObj[name] = "Password and Confirm Password does not match.";
          }
          break;
        case "aadharCard":
          if (!value) {
            stateObj[name] = "Please Enter AadharCard.";
          }
          else if (value.length < 12) {
            stateObj[name] = "Should be 12 digit AadharCard Number"
          }
          // if (value) {
          //   stateObj[name] = [/[0-9]/].every((pattern) =>
          //     pattern.test(value)
          //   ) || "Invalid AadharCard Number"
          // }
          break;
        default:
          break;
      }
      return stateObj;
    });
  }
  return (
    <div className='authentication h-100 p-meddle'>
      <div className='container'
        // h-100
        style={{ background: '#fff' }}
      >

        <div className='row justify-content-center h-100 align-items-center'>
          <div className='col-md-3 show-results'>
            <img src={registerImg} style={{ width: '250px' }} />
          </div>
          <div className='col-md-6'>
            <div className='authentication-content'>
              <div className='row no-gutters'>
                <div className='col-xl-12'>
                  <div className='auth-form'>
                    <div className='text-center mb-3'>
                      <Link to='/'>
                        {/* <img src={icon} alt /> */}
                        <img className="" src={adhaan} alt="" />
                      </Link>
                    </div>
                    <h4 className='text-center mb-4 text-#58595b'>
                      Sign up your account
                    </h4>
                    <form action='' method="post" onSubmit={(e) => submitHandler(e)}>
                      <div className='form-group '>
                        <label className='mb-1 text-#58595b'>
                          <strong>Name</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className={error.agentName.length > 0 ? "is-invalid form-control" : "form-control Color-box"}
                          placeholder='Name'
                          defaultValue={state.agentName}
                          name='agentName'
                          type='text'
                          minLength="3"
                          // onChange={handleBlur}
                          value={input.agentName}
                          onChange={onInputChange}
                          onBlur={validateInput}>
                        </input>
                        {error.agentName && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.agentName}</span>}

                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Email</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type='email'
                          defaultValue={state.emailId}
                          className={error.emailId.length > 0 ? "is-invalid form-control" : "form-control Color-box"}
                          placeholder='Email'
                          name='emailId'
                          value={input.emailId}
                          onChange={onInputChange}
                          onBlur={validateInput}>
                        </input>
                        {error.emailId && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.emailId}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Mobile Number</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type='number' onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          className={error.mobileNumber.length > 0 ? "is-invalid form-control remove-spin" : "form-control Color-box remove-spin"}
                          placeholder='+91 (XXX) XXX-XXXX'
                          defaultValue={state.mobileNumber}
                          name='mobileNumber'
                          // onChange={handleBlur}
                          value={input.mobileNumber}
                          onChange={onInputChange}
                          onBlur={validateInput}>
                        </input>
                        {error.mobileNumber && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.mobileNumber}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Password</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          name="password"
                          placeholder='Enter Password'
                          maxLength="12"
                          minLength="6"
                          defaultValue={state.password}
                          className={error.password.length > 0 ? "is-invalid form-control" : "form-control Color-box"}
                          value={input.password}
                          onChange={onInputChange}
                          onBlur={validateInput}

                        >
                        </input>
                        {error.password && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.password}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Confirm Password</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          name="confirmPassword"
                          placeholder='Enter Confirm Password'
                          maxLength="12"
                          minLength="6"
                          className={error.confirmPassword.length > 0 ? "is-invalid form-control" : "form-control Color-box"}
                          defaultValue={state.password}
                          value={input.confirmPassword}
                          onChange={onInputChange}
                          onBlur={validateInput}
                        ></input>
                        {error.confirmPassword && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.confirmPassword}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Aadhar card Number</strong>
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type='number' onInput={(e) => {
                            if (e.target.value.length > 12) {
                              e.target.value = e.target.value.slice(0, 12);
                            }
                          }}
                          // maxLength="12"
                          // minLength="12"
                          // className={error.aadharCard.length > 0 ? "is-invalid form-control" : "form-control Color-box"}
                          className={error.aadharCard.length > 0 ? "is-invalid form-control remove-spin" : "form-control Color-box remove-spin"}
                          defaultValue={state.aadharCard}
                          placeholder='XXXX-XXXX-XXXX'
                          name='aadharCard'
                          // onChange={handleBlur}
                          value={input.aadharCard}
                          onChange={onInputChange}
                          onBlur={validateInput}>
                        </input>
                        {error.aadharCard && <span style={{ color: 'red', fontSize: '13px', marginLeft: '10px' }} className='err'>{error.aadharCard}</span>}
                      </div>
                      <div className='form-group'>
                        <label className='mb-1 text-#58595b'>
                          <strong>Pan Number</strong>
                          <span className="text-danger"> (optional) </span>
                        </label>
                        <input
                          type='text'
                          className='form-control Color-box'
                          placeholder='XXXXXXXXXX'
                          defaultValue={state.panCard}
                          name='panCard'
                          minLength="3"
                          maxLength="10"
                          onChange={handleBlur}
                        />
                      </div>
                      <div className='text-center mt-4'>
                        {
                          isSpin ?
                            <button
                              type="button"
                              className="btn bg-white text-primary">
                              <CircularProgress
                                color='inherit' size={24}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <button style={{ border: 'none', backgroundColor: '#00ADEE', textAlign: 'center' }}
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={(e) => submitHandler(e)}
                            >
                              Sign Up
                            </button>
                        }
                        &nbsp;&nbsp;
                        <button style={{ border: 'none', backgroundColor: '#00ADEE', marginTop: 21, marginBottom: 21 }}
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={clearFilter}
                        >Cancel
                        </button>
                        <ToastContainer />
                      </div>
                    </form>
                    <div className='new-account mt-3 text-#58595b'>
                      <p>
                        Already have an account?{' '}
                        <Link style={{ color: '#00ADEE' }} to='/page-login'>
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3 show-results'>
            <img src={registerImg1} style={{ width: '270px', top: '-330px', position: 'relative' }} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Register